import React from "react";
import Emitter from "../EventEmitter/EventEmitter";
import {ConstantEventEmitter} from "../data/ConstantEventEmitter";
import {GlobalConstants} from "../data/GlobalConstants";
import {useDispatch} from "react-redux";


const Tracker = ({steps = []}) => {

  const dispatch = useDispatch();

  const handleChangeClickedTab = (tabId) => {

    const selectTab = () => {
      let arrStateTrackerClone = steps.slice();

      for(let item of arrStateTrackerClone){

        item.selected = false;
        if(item.id === tabId){
          item.selected = true;
          item.completed = false;
        }
        if(Number(item.id) > tabId){
          item.completed = false;
        }

      }

      Emitter.emit(ConstantEventEmitter.handleClickTabTracker, arrStateTrackerClone);
    }

    if(tabId === 1){

      selectTab();

      return;
    }

    let isCompleteLast = false;

    for(let item of steps){

      if(item.id === tabId - 1){
        if(!item.completed){
          dispatch({type: 'setStateAlert', alert: {type: GlobalConstants.alertError, message: "No se ha completado el paso anterior"}});
        }
        else{
          isCompleteLast = true;
        }
        break;
      }

    }

    if(isCompleteLast){

      selectTab();

    }

  }

  return(
    <div className="container padding-bottom-3x mb-1 px-0">
      <div className="card mb-3 border-0">
        <div className="card-body p-2">
          <div className="tracker steps d-flex flex-wrap flex-sm-nowrap justify-content-between padding-top-2x mt-2 padding-bottom-1x">
            {
              steps.map((item) => (
                <div onClick={() => handleChangeClickedTab(item.id)}
                     key={`tab${item.id}`} className={item.completed ? item.selected ? "step selected" : "step completed" : item.selected ? "step selected" : "step"}
                     style={{cursor: "pointer"}}>
                  <div className="step-icon-wrap">
                    <div className="step-icon"><i className={item.icon}/></div>
                  </div>
                  <h4 className="step-title">{item.text}</h4>
                </div>
              ))
            }
          </div>

          <div className="my-2 border-content">
            {
              steps.map((item) => (
                <div key={`content${item.id}`} className="w-100 h-100">
                  {
                    item.selected &&
                    item.component
                  }
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  )

}

export default Tracker;
